import { useFetch } from '@/modules/core/composables/useFetch'

interface LoginPayload {
  email: string
  password: string
  remember_device?: boolean
}

interface EnablePayload {
  two_factor_phone_number: string
}

interface PasswordResetPayload {
  email: string
}

interface ResetPasswordPayload {
  reset_token: string
  new_password: string
}

interface VerificationPayload {
  channel: string
}

// prettier-ignore
export const loginService = (payload: LoginPayload) => useFetch('/v4/auth/login').post(payload)
// prettier-ignore
export const verifyService = (payload: { verification_code: string }) => useFetch('/v4/auth/verify').post(payload)
// prettier-ignore
export const enableTwoFactorService = (payload: EnablePayload) => useFetch('/v4/auth/enable-two-factor-authentication').post(payload)
// prettier-ignore
export const skipEnableTwoFactorService = () => useFetch('/v4/auth/skip-enable-two-factor-authentication').post()
// prettier-ignore
export const requestVerificationService = (payload: VerificationPayload) => useFetch('/v4/auth/send-verification-code').post(payload)
// prettier-ignore
export const requestPasswordResetService = (payload: PasswordResetPayload) => useFetch('/v4/auth/request-password-reset').post(payload)
// prettier-ignore
export const resetPasswordService = (payload: ResetPasswordPayload) => useFetch('/v4/auth/reset-password').post(payload)
// prettier-ignore
export const requestTwoFactorAuthenticationResetService = (payload: PasswordResetPayload) => useFetch('/v4/auth/request-two-factor-authentication-reset').post(payload)
// prettier-ignore
export const resetTwoFactorAuthenticationService = (payload: ResetPasswordPayload) => useFetch('/v4/auth/reset-two-factor-authentication').post(payload)
